import { FileText } from 'react-feather';
import { getLanguage, translate } from 'react-switch-lang';
import { Card, CardBody, Container } from 'reactstrap';
import styles from './mentions-legales-page.module.scss';
import { MENTIONS_LEGALES_CONTENT, MentionsLegalesLocale } from './mentionsLegalesContent';

const appVersion = process.env.REACT_APP_VERSION ?? '1.0.0';

const MentionsLegalesPage: React.FC = () => {
  const locale = getLanguage() as MentionsLegalesLocale;
  const content = MENTIONS_LEGALES_CONTENT[locale] ?? MENTIONS_LEGALES_CONTENT.fr;
  const versionText = appVersion ? `AgriSED ${appVersion}` : 'AgriSED';

  return (
    <div className={styles.wrapper}>
      <Container fluid className={styles.inner}>
        <Card className={styles.card}>
          <CardBody className={styles.cardBody}>
            <div className={styles.header}>
              <div className={styles.headerIcon}>
                <FileText size={20} />
              </div>
              <h2 className={styles.title}>{content.title}</h2>
            </div>
            <p className={styles.intro}>{content.intro}</p>

            <div className={styles.section}>
              <div className={styles.sectionTitle}>{content.versionLabel}</div>
              <p className={styles.paragraph}>{versionText}</p>
            </div>

            {content.sections.map((section) => (
              <div className={styles.section} key={section.title}>
                <div className={styles.sectionTitle}>{section.title}</div>
                {section.paragraphs.map((paragraph) => (
                  <p className={styles.paragraph} key={paragraph}>
                    {paragraph}
                  </p>
                ))}
              </div>
            ))}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default translate(MentionsLegalesPage);
